import { x } from '../../utils';

// This module will hold all items associated with a specific collection
function Storage(collection, config) {
    this.collection = collection;

    // Function to find out if an item can be removed
    // e.g. no one is subscribing to this item.
    this.itemIsRemovable = config.itemIsRemovable;

    // Max size for this storage
    this.maxSize = config.maxSize;

    // If true, items can be removed by a garbage collector
    // since there is a network provider attached.
    this.restorable = config.restorable || false;

    // Actual data storage
    this.items = {};

    // Size of this storage, should always be up to date
    this.storageSize = 0;
}

Storage.prototype.get = function (identifier) {
    const result = {};
    result.item = this.items[identifier];
    if (result.item) {
        result.item.touch();
    } else {
        result.error = new Error('object not found');
    }
    return result;
};

Storage.prototype.getAll = function () {
    const items = this.items;
    return Object.keys(items).map(identifier => {
        const item = items[identifier];
        item.touch();
        return item;
    });
};

Storage.prototype.save = function (identifier, item) {
    // Remove old item (if exists)
    removeItem.call(this, identifier);

    this.items[identifier] = item;
    this.storageSize += item.getSize();
};

Storage.prototype.remove = function (identifier) {
    const result = removeItem.call(this, identifier);

    return result.item
        ? result
        : {
              error: new Error('object not found'),
          };
};

Storage.prototype.instrumentation = function () {
    const self = this;
    return {
        __name__: self.collection,
        storageSize: this.storageSize,
        maxSize: this.maxSize,
        restorable: this.restorable,
        items: this.items,
        getRemovables: function () {
            const result = {};
            Object.keys(self.items).forEach(function (key) {
                result[key] = self.itemIsRemovable(self.collection, key);
            });
            return result;
        },
    };
};

/*
 * This will return an array of items that the garbage collector will use in order to free space
 *
 * properties in the list entries are:
 *  * lastTouched
 *  * size
 *  * collection
 *  * identifier
 *  * remove: function that gc will call to remove this element
 */
Storage.prototype.getRemovables = function () {
    const self = this;
    if (!this.restorable) {
        return [];
    }
    return Object.keys(self.items).map(function (identifier) {
        const item = self.items[identifier];
        return x.extend(x.pick(item, 'lastTouched'), {
            size: item.getSize(),
            collection: self.collection,
            identifier: identifier,
            remove: function () {
                if (self.itemIsRemovable(this.collection, this.identifier)) {
                    removeItem.call(self, identifier);
                    return true;
                }
                return false;
            },
        });
    });
};

function removeItem(identifier) {
    const itemToRemove = this.items[identifier];
    let removedSize = 0;

    if (itemToRemove) {
        delete this.items[identifier];
        removedSize = itemToRemove.getSize();
        this.storageSize -= removedSize;
    }
    return {
        item: itemToRemove,
        size: removedSize,
    };
}

export default Storage;
